import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-content">
        <div className="loading-spinner"></div>
        <h2 className="loading-title">
          Loading Duelity Gaming...
        </h2>
        <p className="loading-description">
          Please wait while we prepare your gaming experience
        </p>
        <div className="loading-progress">
          <div className="loading-progress-bar"></div>
        </div>
        <div className="loading-dots">
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;